import script from "./PostListView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostListView.vue?vue&type=script&lang=ts&setup=true"

import "./PostListView.vue?vue&type=style&index=0&id=3174bea6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/posuto/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3174bea6"]])

export default __exports__